module.exports = __webpack_public_path__ + "img/emoji-sleepy-240x240.d65a0cbb.png";